import { render, staticRenderFns } from "./inspectiondetail.vue?vue&type=template&id=92f08f26&scoped=true"
import script from "./inspectiondetail.vue?vue&type=script&lang=js"
export * from "./inspectiondetail.vue?vue&type=script&lang=js"
import style0 from "./inspectiondetail.vue?vue&type=style&index=0&id=92f08f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f08f26",
  null
  
)

export default component.exports